
// @ts-nocheck


export const localeCodes =  [
  "da",
  "de",
  "el",
  "en",
  "es",
  "fr",
  "hu",
  "it",
  "ja",
  "pl",
  "pt",
  "ru",
  "sv",
  "tr",
  "zh",
  "ae"
]

export const localeLoaders = {
  "da": [{ key: "../locales/da.json", load: () => import("../locales/da.json" /* webpackChunkName: "locale__app_locales_da_json" */), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => import("../locales/de.json" /* webpackChunkName: "locale__app_locales_de_json" */), cache: true }],
  "el": [{ key: "../locales/fr.json", load: () => import("../locales/fr.json" /* webpackChunkName: "locale__app_locales_fr_json" */), cache: true }],
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__app_locales_en_json" */), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => import("../locales/es.json" /* webpackChunkName: "locale__app_locales_es_json" */), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => import("../locales/fr.json" /* webpackChunkName: "locale__app_locales_fr_json" */), cache: true }],
  "hu": [{ key: "../locales/hu.json", load: () => import("../locales/hu.json" /* webpackChunkName: "locale__app_locales_hu_json" */), cache: true }],
  "it": [{ key: "../locales/it.json", load: () => import("../locales/it.json" /* webpackChunkName: "locale__app_locales_it_json" */), cache: true }],
  "ja": [{ key: "../locales/ja.json", load: () => import("../locales/ja.json" /* webpackChunkName: "locale__app_locales_ja_json" */), cache: true }],
  "pl": [{ key: "../locales/pl.json", load: () => import("../locales/pl.json" /* webpackChunkName: "locale__app_locales_pl_json" */), cache: true }],
  "pt": [{ key: "../locales/pt.json", load: () => import("../locales/pt.json" /* webpackChunkName: "locale__app_locales_pt_json" */), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => import("../locales/ru.json" /* webpackChunkName: "locale__app_locales_ru_json" */), cache: true }],
  "sv": [{ key: "../locales/sv.json", load: () => import("../locales/sv.json" /* webpackChunkName: "locale__app_locales_sv_json" */), cache: true }],
  "tr": [{ key: "../locales/tr.json", load: () => import("../locales/tr.json" /* webpackChunkName: "locale__app_locales_tr_json" */), cache: true }],
  "zh": [{ key: "../locales/zh.json", load: () => import("../locales/zh.json" /* webpackChunkName: "locale__app_locales_zh_json" */), cache: true }],
  "ae": [{ key: "../locales/ae.json", load: () => import("../locales/ae.json" /* webpackChunkName: "locale__app_locales_ae_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "da",
      "files": [
        "/app/locales/da.json"
      ]
    },
    {
      "code": "de",
      "files": [
        "/app/locales/de.json"
      ]
    },
    {
      "code": "el",
      "files": [
        "/app/locales/fr.json"
      ]
    },
    {
      "code": "en",
      "files": [
        "/app/locales/en.json"
      ]
    },
    {
      "code": "es",
      "files": [
        "/app/locales/es.json"
      ]
    },
    {
      "code": "fr",
      "files": [
        "/app/locales/fr.json"
      ]
    },
    {
      "code": "hu",
      "files": [
        "/app/locales/hu.json"
      ]
    },
    {
      "code": "it",
      "files": [
        "/app/locales/it.json"
      ]
    },
    {
      "code": "ja",
      "files": [
        "/app/locales/ja.json"
      ]
    },
    {
      "code": "pl",
      "files": [
        "/app/locales/pl.json"
      ]
    },
    {
      "code": "pt",
      "files": [
        "/app/locales/pt.json"
      ]
    },
    {
      "code": "ru",
      "files": [
        "/app/locales/ru.json"
      ]
    },
    {
      "code": "sv",
      "files": [
        "/app/locales/sv.json"
      ]
    },
    {
      "code": "tr",
      "files": [
        "/app/locales/tr.json"
      ]
    },
    {
      "code": "zh",
      "files": [
        "/app/locales/zh.json"
      ]
    },
    {
      "code": "ae",
      "files": [
        "/app/locales/ae.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "da",
    "files": [
      {
        "path": "/app/locales/da.json"
      }
    ]
  },
  {
    "code": "de",
    "files": [
      {
        "path": "/app/locales/de.json"
      }
    ]
  },
  {
    "code": "el",
    "files": [
      {
        "path": "/app/locales/fr.json"
      }
    ]
  },
  {
    "code": "en",
    "files": [
      {
        "path": "/app/locales/en.json"
      }
    ]
  },
  {
    "code": "es",
    "files": [
      {
        "path": "/app/locales/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "/app/locales/fr.json"
      }
    ]
  },
  {
    "code": "hu",
    "files": [
      {
        "path": "/app/locales/hu.json"
      }
    ]
  },
  {
    "code": "it",
    "files": [
      {
        "path": "/app/locales/it.json"
      }
    ]
  },
  {
    "code": "ja",
    "files": [
      {
        "path": "/app/locales/ja.json"
      }
    ]
  },
  {
    "code": "pl",
    "files": [
      {
        "path": "/app/locales/pl.json"
      }
    ]
  },
  {
    "code": "pt",
    "files": [
      {
        "path": "/app/locales/pt.json"
      }
    ]
  },
  {
    "code": "ru",
    "files": [
      {
        "path": "/app/locales/ru.json"
      }
    ]
  },
  {
    "code": "sv",
    "files": [
      {
        "path": "/app/locales/sv.json"
      }
    ]
  },
  {
    "code": "tr",
    "files": [
      {
        "path": "/app/locales/tr.json"
      }
    ]
  },
  {
    "code": "zh",
    "files": [
      {
        "path": "/app/locales/zh.json"
      }
    ]
  },
  {
    "code": "ae",
    "files": [
      {
        "path": "/app/locales/ae.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
